import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Leaf, BrainCircuit, Satellite, Globe, Mail } from 'lucide-react';
import Navbar from '../components/Navbar';

export default function AboutPage() {
  const navigate = useNavigate();

  return (
    <div className="page-wrapper">
      <Navbar />
      <div className="page-content">
        <section className="about-section" id="about">
          <div className="container">
            <div className="about-content">
              <div className="section-header-centered">
                <div className="section-badge"><Leaf size={14} /> ABOUT BOAI</div>
                <h2>Best of Agro Intelligence</h2>
                <h3 className="hindi-text">कृषि बुद्धिमत्ता का सर्वश्रेष्ठ मंच</h3>
              </div>

              {/* Tech Images Showcase */}
              <div className="about-tech-images">
                <div className="tech-image-card">
                  <img src="https://images.pexels.com/photos/16678079/pexels-photo-16678079.jpeg?auto=compress&cs=tinysrgb&w=400" alt="AI Mobile Farming" />
                  <span>AI-Powered Mobile</span>
                </div>
                <div className="tech-image-card">
                  <img src="https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=400" alt="Data Analytics" />
                  <span>Smart Analytics</span>
                </div>
                <div className="tech-image-card">
                  <img src="https://images.pexels.com/photos/34182314/pexels-photo-34182314.jpeg?auto=compress&cs=tinysrgb&w=400" alt="Drone Technology" />
                  <span>Drone Monitoring</span>
                </div>
                <div className="tech-image-card">
                  <img src="https://images.unsplash.com/photo-1627920769842-6887c6df05ca?w=400" alt="Robotics" />
                  <span>Smart Robotics</span>
                </div>
              </div>

              <div className="about-mission">
                <p>
                  BoAI (Best of Agro Intelligence) is a unified AI platform on a mission to make every farmer
                  globally empowered through AI-driven precision farming, robotics automation, and sustainable
                  agri-intelligence. We combine AI crop diagnosis, expert consultations, agri-commerce, farmer
                  community, and advanced data analytics into one powerful ecosystem — solving the problems that
                  have plagued Indian agriculture for decades: delayed disease detection, middlemen exploitation,
                  poor supply chains, and lack of affordable technology access.
                </p>
                <p className="about-mission-hi">
                  BoAI (बेस्ट ऑफ एग्रो इंटेलिजेंस) एक एकीकृत AI मंच है जो हर किसान को AI-संचालित सटीक खेती,
                  रोबोटिक्स ऑटोमेशन, और टिकाऊ कृषि बुद्धिमत्ता के माध्यम से सशक्त बनाने के मिशन पर है।
                  हम AI फसल निदान, विशेषज्ञ परामर्श, कृषि वाणिज्य, किसान समुदाय और उन्नत डेटा विश्लेषण को
                  एक शक्तिशाली पारिस्थितिकी तंत्र में जोड़ते हैं।
                </p>
              </div>

              <div className="about-vision-cards">
                <div className="about-vision-card">
                  <BrainCircuit size={28} />
                  <h4>AI-First Approach</h4>
                  <p>Integrating all AI services — from diagnosis to autonomous farming. Building Small Language Models specifically for the agriculture sector.</p>
                </div>
                <div className="about-vision-card">
                  <Satellite size={28} />
                  <h4>Fuelling Sustainability</h4>
                  <p>Tackling climate change through precision agriculture, reducing chemical overuse, and promoting renewable energy integration in farming.</p>
                </div>
                <div className="about-vision-card">
                  <Globe size={28} />
                  <h4>Global Ambition</h4>
                  <p>Starting with India, scaling to the world. Creating intelligent farming solutions from diagnosis to automation, improving productivity worldwide.</p>
                </div>
              </div>

              <div className="founders-section">
                <h3 className="founders-title">Leadership</h3>
                <div className="founders-grid">
                  <div className="founder-card" data-testid="founder-siddharth">
                    <div className="founder-avatar">
                      <div className="founder-initials">SS</div>
                    </div>
                    <h4>Siddharth Singh</h4>
                    <p className="founder-role">CEO & Co-Founder</p>
                    <p className="founder-desc">Product visionary leading BoAI's technology strategy, AI development, and platform architecture. Driving the mission to transform agriculture through intelligent technology.</p>
                    <a href="mailto:siddharth.s@boai.in" className="founder-contact">
                      <Mail size={14} /> siddharth.s@boai.in
                    </a>
                  </div>
                  <div className="founder-card" data-testid="founder-ankit">
                    <div className="founder-avatar">
                      <div className="founder-initials">AT</div>
                    </div>
                    <h4>Ankit Tripathi</h4>
                    <p className="founder-role">Co-Founder & Chief Food Operations Officer (CFOO)</p>
                    <p className="founder-desc">Leads end-to-end food production, packaging, quality control, and distribution operations for BOAI's healthy food product line. Oversees sourcing coordination, manufacturing efficiency, packaging standards, inventory planning, and dispatch management to ensure consistent product quality and timely market delivery. Works closely with procurement teams, warehouse partners, and distributors to optimize operational scalability and maintain compliance with food safety standards.</p>
                  </div>
                </div>
              </div>

              <div className="page-cta-bar">
                <button className="btn-primary" onClick={() => navigate('/auth')}>
                  Join BoAI Network
                </button>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}
